import { POST } from './../api';

export const getStatsCallsInformation = (data) => {
  return POST('/stats/calls', data);
}
